/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
import { ATTR_SESSION_ID } from './semconv';
/**
 * SessionSpanProcessor is a {@link SpanProcessor} that adds the session.id attribute
 */
export class SessionSpanProcessor {
    _sessionIdProvider;
    constructor(sessionIdProvider) {
        this._sessionIdProvider = sessionIdProvider;
    }
    /**
     * Forces to export all finished spans
     */
    async forceFlush() { }
    /**
     * Called when a {@link Span} is started, if the `span.isRecording()`
     * returns true.
     * @param span the Span that just started.
     */
    onStart(span, _parentContext) {
        const sessionId = this._sessionIdProvider?.getSessionId();
        if (sessionId) {
            span.setAttribute(ATTR_SESSION_ID, sessionId);
        }
    }
    /**
     * Called when a {@link ReadableSpan} is ended, if the `span.isRecording()`
     * returns true.
     * @param span the Span that just ended.
     */
    onEnd(_) {
        // no-op
    }
    /**
     * Shuts down the processor. Called when SDK is shut down. This is an
     * opportunity for processor to do any cleanup required.
     */
    async shutdown() { }
}
//# sourceMappingURL=SessionSpanProcessor.js.map